import React from 'react';
import { Container, Bar, Dimmed } from './ProgressBar.style';

const ProgressBar = ({ color, progress, max = 100, dimmed, roundBorder }) => {
    return (
        <Container round={roundBorder}>
            <Bar width={(progress / max) * 100} backgroundColor={color} />
            {dimmed && <Dimmed />}
        </Container>
    );
};

export { ProgressBar };
